 import { default as Axios } from "axios";
import { TokenExpiredError } from "jsonwebtoken";
import qs from 'qs';
import { AuthActionType, HAS_ERRORS } from './actionTypes';
// import updateAbility from "../config/ability";
// import { AbilityContext } from "../config/Can";
import { BASEURL2, HEADERS } from './index';

const baseUrl = "http://localhost:8081";
const headers = {
    'Content-Type': 'application/x-www-form-urlencoded',
    // 'Connection': 'close',
    // 'Access-Control-Allow-Origin': '*'
}

// //response interceptor to refreshToken on receiving token expired error
// Axios.interceptors.response.use(
//     (response) => {
//         console.log('AuthAction Axios.interceptors.response called');
    
//         return response;
//     },
//     async function(error){
//         // //TODO: NOT FOR PYTHON LOGIN YET
//         // try {
//         //     const originalRequest = error.config;
//         //     let refreshToken = localStorage.getItem("refreshToken");
//         //     console.log('AuthAction Axios.interceptors.response refreshToken: ' + JSON.stringify(refreshToken));

//         //     console.log('AuthAction Axios.interceptors.response originalRequest: ' + JSON.stringify(originalRequest));
//         //     console.log('AuthAction Axios.interceptors.response error: ' + JSON.stringify(error));
//         //     console.log('AuthAction Axios.interceptors.response error.response.status: ' + JSON.stringify(error.response.status));
//         //     console.log('AuthAction Axios.interceptors.response originalRequest._retry: ' + JSON.stringify(originalRequest._retry));

//         //     if(error.response?.status !== 401) {
//         //         console.log('AuthAction Axios.interceptors.response error.response?.status: ' + JSON.stringify(error.response?.status));

//         //         return Promise.reject(error);
//         //     }

//         //     if ( (refreshToken !== "" && refreshToken !== null && refreshToken !== undefined) && error.response.status === 401 && !originalRequest._retry){
//         //         console.log('AuthAction Axios.interceptors.response retrying originalRequest._retry:' + JSON.stringify(originalRequest._retry));
//         //         originalRequest._retry = true;
    
//         //         return Axios.post(`${baseUrl}/token`, {refreshToken: refreshToken})
//         //             .then((res) => {
//         //                 console.log('AuthAction Axios.interceptors.response Axios.post res:' + JSON.stringify(res));

//         //                 if(res.status === 200){
//         //                     localStorage.setItem("accessToken", res.data.message['accessToken']);
//         //                     console.log('Access token refreshed!');
//         //                     return Axios(originalRequest);
//         //                 }
//         //                 else{
//         //                     console.log('AuthAction Axios.interceptors.response res.err: ' + res.err);   
//         //                     return Promise.reject(error);                             
//         //                 }
//         //             });
//         //     }            
//         // } catch (err) {
//         //     console.log('AuthAction Axios.interceptors.response err: ' + err);   
//         //     return Promise.reject(error); 
//         // }
        
//         // return Promise.reject(error);
//     }
// );

//WITH PYTHON METHOD
const LoginAuthAction = (loginState) => {
    return async (dispatch) => {
        try{
            //VALIDATE input was entered

            //todo check loginState from server; ex:
            const res = await Axios.post(`${BASEURL2}/login`, qs.stringify(loginState, {indices: false}), { headers });
            //const res = await Axios.post(`/login`, qs.stringify(loginState, {indices: false}), { headers });
            
            const { data } = res;
            // const data = await fetchLogin(loginState);

            //and data.message is good then proceed in loggin in
            if(typeof(data['ERROR']) === 'undefined' && typeof(data['message']) !== 'undefined' && Object.keys(data['message']).length > 0 ){
                dispatch({
                    type: AuthActionType.LOGIN_SUCCESS,
                    payload: data.message,
                })

                console.log('LoginAuthAction user LOGIN_SUCCESS:' + JSON.stringify(data.message))
                window.location.href='/'
                // //TODO: NOT FOR PYTHON LOGIN YET
                // localStorage.setItem("accessToken", data.message['accessToken'])
                // localStorage.setItem("refreshToken", data.message['refreshToken'])
                // localStorage.setItem("loginToken", data.message['loginToken'])
             
            }
            else{

                var loginFailResponse = 'Login Failed'
                if(typeof(data['ERROR']) !== 'undefined'){
                    loginFailResponse = data['ERROR']
                } 

                dispatch({
                    type: AuthActionType.LOGIN_FAIL,
                    payload: loginFailResponse
                });

                
                dispatch({                    
                    type: HAS_ERRORS,   
                    payload: loginFailResponse
                })    

                console.log('AuthAction LoginAuthAction fail: ' + AuthActionType.LOGIN_FAIL);
            }

        } catch (error) {
            console.log('AuthAction LoginAuthAction error: ' + error);
            if(error){
                dispatch({
                    type: AuthActionType.LOGIN_FAIL,
                    payload: error.toString() //error.response.data.message
                });
            }
                
            dispatch({                    
                type: HAS_ERRORS,   
                payload: error.toString() //error.response.data.message
            })    
        
        }

    };
};

const LoginJWTAuthAction = (loginState, history, setErrorHandler) => {
    return async (dispatch) => {
        try{
            const res = await Axios.post(`${baseUrl}/loginJWT`, loginState);
            const { data } = res;
            //console.log('AuthAction LoginJWTAuthAction data: ' + data);

            if(typeof(data.message['ERROR']) !== 'undefined'){
                dispatch({
                    type: AuthActionType.LOGIN_FAIL,
                    payload:  data.message['ERROR']
                });

                dispatch({                    
                    type: HAS_ERRORS,   
                    payload: data.message['ERROR']
                }) 

            }
            else{
                dispatch({
                    type: AuthActionType.LOGIN_SUCCESS,
                    payload: data.message,
                });    
                
                // localStorage.setItem("accessToken", data.message['accessToken'])
                // localStorage.setItem("refreshToken", data.message['refreshToken'])
                
                //const ability = new Ability([], { subjectName })
                //updateAbility(ability, data.message.user)

                history.push("/");
    
                console.log('AuthAction LoginJWTAuthAction success: ' + AuthActionType.LOGIN_SUCCESS);
            
            }            
        } catch (error) {
            if(error){
                dispatch({
                    type: AuthActionType.LOGIN_FAIL,
                    payload:  error.toString() //error.response.data.message
                });
            }

            dispatch({                    
                type: HAS_ERRORS,   
                payload: error.toString() //error.response.data.message
            }) 
        }
    };
};

const LogOutAuthAction = (history) => {
    return async (dispatch) => {
        try { 
            //todo get response from server i.e.
            //const res = await Axios.post('/logout');
            //const { data } = res;
            const data = '123';

            dispatch({
                type: AuthActionType.LOGOUT_SUCCESS,
                //payload: data.message,
                payload: {}, //remove and and use above
            })        
                   
            history.push("/login");            
        } catch (error) {
            console.log('AuthAction LogOutAuthAction error: ' + error);
            console.log('AuthAction LogOutAuthAction error.response: ' + error.response);
            if(error.response){
                dispatch({
                    type: AuthActionType.LOGOUT_FAIL,
                    payload: error.response.data.message,
                });
            }
            console.log('AuthAction LogOutAuthAction AuthActionType.LOGOUT_FAIL: ' + AuthActionType.LOGOUT_FAIL);            

        }
    };
};

const LogoutJWTAuthAction = (history) => {
    return async (dispatch) => {
        try { 
            //todo get response from server i.e.
            //const res = await Axios.post('/logout');
            //const { data } = res;
            const data = '123';

            dispatch({
                type: AuthActionType.LOGOUT_SUCCESS,
                //payload: data.message,
                payload: {}, //remove and and use above
            })

            localStorage.removeItem("accessToken");
            localStorage.removeItem("refreshToken");            
            history.push("/login");

        } catch (error) {
            console.log('AuthAction LogoutJWTAuthAction error: ' + error);          
        }
    };
};

//WITH PYTHON METHOD
const RegisterAuthAction = (registerState, history) => {
    return async (dispatch) => {
        try{
            //VALIDATE input was entered

            //todo check registerState from server; ex:
            const res = await Axios.post(`${BASEURL2}/register`, qs.stringify(registerState, {indices: false}), { headers });
            const { data } = res;
            
            //and data.message is good then proceed in loggin in  --  && Object.keys(data['message']).length > 0
            if(typeof(data['ERROR']) === 'undefined' && typeof(data['message']) !== 'undefined' && Object.keys(data['message']).length > 0){
                dispatch({
                    type: AuthActionType.REGISTER_SUCCESS,
                    payload: data.message,
                });
    
                //UNNEEDED? --- TODO: NOT FOR PYTHON LOGIN YET
                // localStorage.setItem("accessToken", data.message['accessToken'])
                // localStorage.setItem("refreshToken", data.message['refreshToken'])
                // localStorage.setItem("loginToken", data.message['loginToken'])
                
                history.push({pathname:"/login", registeredEmail: registerState['email']});
            }
            else{                          

                var errResponse = 'Registration failed'
                if(typeof(data['ERROR']) !== 'undefined'){
                    errResponse = data['ERROR']
                } 

                dispatch({
                    type: AuthActionType.REGISTER_FAIL,
                    payload: errResponse
                });

                dispatch({                    
                    type: HAS_ERRORS,   
                    payload: errResponse
                }) 

                console.log('AuthAction RegisterAuthAction fail: ' + AuthActionType.REGISTER_FAIL);
            }


        } catch (error) {
            console.log('AuthAction RegisterAuthAction error: ' + error);
            if(error){
                dispatch({
                    type: AuthActionType.REGISTER_FAIL,
                    payload:  error.toString() //error.response.data.message
                });
            }

            dispatch({                    
                type: HAS_ERRORS,   
                payload: error.toString() //error.response.data.message
            }) 
        }

    };
};

export { LogOutAuthAction, LoginAuthAction, LoginJWTAuthAction, LogoutJWTAuthAction, RegisterAuthAction };